import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { LookupData } from '../models/lookup';
import { map } from 'rxjs/operators';
import { ApiResult } from '../models/ApiResult';

@Injectable({
  providedIn: 'root'
})
export class INMTasacionesService {

  myAppUrl = '';

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getINMTasaciones() {
    return this._http.get(this.myAppUrl + 'api/INMTasaciones/');
  }

  getINMTasacionesFiltered(searchTerm: string) {
    return this._http.get(this.myAppUrl + 'api/INMTasaciones?k=' + searchTerm);
  }

  getINMTasacionesID(id: number) {
    return this._http.get(this.myAppUrl + 'api/INMTasaciones/' + id);
  }

  deleteTasaciones(list:number[]) : Observable<ApiResult>
  {

    let httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json');   
    let options = {
    headers: httpHeaders
    };   
    let miJson = JSON.stringify(list);

    return this._http.post<ApiResult>(this.myAppUrl + 'api/INMTasaciones/DeleteTasacion', miJson, options);

  }

}
